import {api} from '../../api/common.js'
import { api as reportApi} from '../../api/reportsAPI.js'

const data = {
  createLor:(args) => new Promise((resolve, reject) => {
reportApi.post('/lor',args).then(function (response) {
  resolve(response)
})
.catch((error) => {
  reject(error)
})

  }),
    getTutorInvoices:(args) => new Promise((resolve, reject) => {
        console.log('args',args)
        api.get('/invoices/filter?userId='+args)
        .then(function (response) {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    }),
    invoicePaid:(args)=> new Promise((resolve, reject) => {
        console.log('args',args)
        api.get('/invoices/'+args+'/set_paid')
        .then(function (response) {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    }),
    getClassroom: (arg) => new Promise((resolve, reject) => {
      api.get('/tc-products/2/variants/' + arg)
        .then(function (response) {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    }),
    getClassroomsByTutorId:({...args})=>  new Promise((resolve, reject) => {
      api.get('/classrooms/filter?meta[tutor-id]='+args.tutorid+'&dateFrom='+args.dateFrom+'&orderBy=dateFrom&orderDirection=ASC')
      .then(function (response) {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
    }),
    getOrdersByClassroomId: (id) => new Promise((resolve, reject) => {
      api.get('/tc-orders/filter/?detailed=true&productVariantId=' + id + '&statuses=["fullyPaid","partiallyPaid","reserved"]')
      .then(function (response) {
          // console.log('departureinfo: ', response)
        resolve(response.data)
      })
      .catch((error) => {
        reject(error)
      })
    }),
   setUserAttended:({...args}) => new Promise((resolve, reject) => {
console.log(args)
var data={}
data.attended=args.value;
 api.post('tc-orders/'+ args.orderid+'/set_internal_user_meta_data',args).then(function (response) {
  // console.log('departureinfo: ', response)
  console.log(response)
resolve(response.data)
})
.catch((error) => {
reject(error)
}) 
   }),
   setUserPassed:({...args}) => new Promise((resolve, reject) => {
    console.log(args)
    var data={}
    data.attended=args.value;
     api.post('tc-orders/'+ args.orderid+'/set_internal_user_meta_data',args).then(function (response) {
      // console.log('departureinfo: ', response)
      console.log(response)
    resolve(response.data)
    })
    .catch((error) => {
    reject(error)
    }) 
       }),
       getPrintRegister:(arg) => new Promise((resolve, reject) => {
        reportApi.post('classroom/register',arg,{responseType:'arraybuffer'})
        .then(function (response) {
          
        resolve(response)
      })
      .catch((error) => {
        
       })
      })
}
export default data


// WEBPACK FOOTER //
// ./src/components/Tutor/api.js